/**
 * LookupFieldType — F12.B T12.B.4.
 * Pole read-only pobierające wartość z powiązanego rekordu przez API.
 * Wymaga zapisanego rekordu (recordId) — przy nowym rekordzie nie działa.
 */
import { useQuery } from '@tanstack/react-query';
import { ArrowUpRight, Loader2 } from 'lucide-react';

import { api } from '@/lib/api';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'lookup',
  renderInput: ({ field, recordId }) => {
    const enabled = !!recordId;
    const { data, isLoading, isError } = useQuery<{ value: unknown; relatedRecordId?: string }>({
      queryKey: ['lookup', field.id, recordId],
      queryFn: async () => {
        const res = await api.get<{ value: unknown; relatedRecordId?: string }>(
          `/modules/${field.moduleId}/records/${recordId}/lookup/${field.id}`,
        );
        return res.data;
      },
      enabled,
      staleTime: 30_000,
    });

    if (!recordId) {
      return (
        <div className="rounded-lg border border-border-primary bg-bg-secondary px-3 py-2 text-sm italic text-text-muted">
          Zapisz rekord aby zobaczyć wartość lookup
        </div>
      );
    }
    if (isLoading) {
      return (
        <div className="flex items-center gap-2 rounded-lg border border-border-primary bg-bg-secondary px-3 py-2">
          <Loader2 className="h-4 w-4 animate-spin text-accent-600" />
          <span className="text-sm text-text-secondary">Ładowanie…</span>
        </div>
      );
    }
    if (isError) {
      return (
        <div className="rounded-lg border border-danger-200 bg-danger-50 px-3 py-2 text-sm text-danger-600">
          Błąd pobierania wartości
        </div>
      );
    }

    return (
      <div className="rounded-lg border border-accent-200 bg-accent-50 px-3 py-2">
        <div className="mb-1 flex items-center justify-between">
          <span className="text-xs font-medium text-accent-600">
            🔗 Lookup z powiązanego rekordu
          </span>
          {data?.relatedRecordId && <ArrowUpRight className="h-4 w-4 text-accent-400" />}
        </div>
        <p className="text-sm font-semibold text-accent-900">
          {data?.value != null ? String(data.value) : '—'}
        </p>
      </div>
    );
  },
  renderCell: (_field, value) => (
    <div className="flex items-center gap-1">
      <ArrowUpRight className="h-3 w-3 text-accent-500" />
      <span className="text-xs text-text-primary">{value != null ? String(value) : '—'}</span>
    </div>
  ),
  validate: () => null,
  defaultValue: null,
});
